'use strict';

import React, { Component } from 'react';
import styles from './assets/indexResponse.module.css';
import LazyImage from '../../components/lazyImage.jsx';

const print = function (value) { };
class DDS_lanhupage_0 extends Component {
  state = {};
  setValue(val) { }
  componentDidMount() {



  };


  render() {
    return (
      <div className={`flex-col ${styles['indexResponse_box1']} indexResponse_indexResponse_box1__2ufYZ`}>
        <div className={`flex-col  ${styles['indexResponse_banner']} indexResponse_indexResponse_banner__1tOV8`} />
        <span className={`${styles['dv_country_item_title']} indexResponse_dv_country_item_title__2wdb6`}>为什么留学西班牙?</span>
        <div className={`${styles['dv_mainbody_wrap_box']} indexResponse_dv_mainbody_wrap_box__JA4P7`}>

          <div className={`${styles['dv_flexcol-two']} indexResponse_dv_flexcol-two__P6mpr`}>
            <div>
              <div className={`${styles['dv_cuoutnry_phy_title']} indexResponse_dv_cuoutnry_phy_title__27bIk`}>选择在西班牙学习的理由</div>
              <div className={`${styles['dv_juzi_wrap']} indexResponse_dv_juzi_wrap__1pBzp`}>
                西班牙是一个开放的欧洲国家，多元文化社会提供高品质的生活和高质量的公立和私立大学教育机会。
                所有的学生都有同样的机会进入最好的大学，因为公立系统奖励学术背景和学生的能力。<br />
                超过50所不同的大学，2000多个学士学位可供选择:
                你将学习一门通用语言，并沉浸在丰富的多元文化中。<br />
                享受这里的生活方式，温和的气候，健康的饮食和全球认可，发现多种休闲文化活动、戏剧、博物馆、展览交易会等。</div>
            </div>

            <div className={`${styles['img_single_right']} indexResponse_img_single_right__2uhZh`}>
              <img
                className='border-radius'
                src={
                  require('./assets/img/2.jpg')
                } />
            </div>
          </div>
          <div className={`${styles['dv_flexcol-two-2']} indexResponse_dv_flexcol-two-2__1mjz3`}>
            <div className={`${styles['img_single_right']} indexResponse_img_single_right__2uhZh`}>
              <LazyImage
                className='border-radius'
                imgUrl={
                  require('./assets/img/3.jpg')
                } />
            </div>
            <div>

              <div className={`${styles['dv_juzi_wrap']} indexResponse_dv_juzi_wrap__1pBzp`}>
                这是一个非常安全友好热情的地中海国际化大都市，有160万人居住，每年700万游客前来参观，巴塞罗那的国际机场，是世界上人流量最高的机场之一，可直达大多数城市。<br />
                这是一个多语言和多文化的城市，因此无论你的国籍是什么，都具有很好的适应性。<br />
                他拥有12所享有盛誉的国际知名大学，在国际学生援助办公室的帮助下，你会有宾至如归的感觉。<br />
                他拥有南欧最大的大学社区之一，拥有超过七百五十八个学士学位和七百多个硕士学位研究生课程，也有国际领先的研发环境，拥有十五个科技园。</div>
            </div>
          </div>
          <div className={`${styles['dv_flexcol-two']} indexResponse_dv_flexcol-two__P6mpr`}>
            <div>
              <div className={`${styles['dv_cuoutnry_phy_title']} indexResponse_dv_cuoutnry_phy_title__27bIk`}>学习西班牙语的理由</div>
              <div className={`${styles['dv_juzi_wrap']} indexResponse_dv_juzi_wrap__1pBzp`}>
                <strong>西班牙语:</strong><br />
                世界上有五亿人使用西班牙语。<br />
                是21个国家的母语。<br />
                <strong>学习西班牙语的好处:</strong><br />
                让你拥有脱颖而出的简历。<br />
                增加人际关系和职业机会<br />
                拥有身临其境的文化体验。</div>
            </div>

            <div className={`${styles['img_single_right']} indexResponse_img_single_right__2uhZh`} style={{ "width": "22vw" }}>
              <LazyImage
                className='border-radius'
                style={{ "margin-top": "4vw" }}
                imgUrl={
                  require('./assets/img/4.jpg')
                } />
            </div>
          </div>

          <div className={`${styles['dv_flexcol-two-2']} indexResponse_dv_flexcol-two-2__1mjz3`}>
            <div className={`${styles['img_single_right']} indexResponse_img_single_right__2uhZh`}>
              <LazyImage
                className={`${styles['border-radius0']}`}
                imgUrl={
                  require('./assets/img/5.jpg')
                } />
            </div>
            <div>
              <div className={`${styles['dv_cuoutnry_phy_title']} indexResponse_dv_cuoutnry_phy_title__27bIk`}>学习西班牙语的目的</div>
              <div className={`${styles['dv_juzi_wrap']} indexResponse_dv_juzi_wrap__1pBzp`}>
                通过西班牙语等级考试后，学生有超过50个公立大学，2000个学士学
                位可供选择。</div>
            </div>

          </div>

          <div className={`${styles['dv_cuoutnry_phy_title']}`}>西班牙大学的分布</div>

          <div className={`${styles['img_single']}`} style={{ "width": "100%" }}>
            <LazyImage
              className='border-radius'
              imgUrl={
                require('./assets/img/6.jpg')
              } />
          </div>

          <div className={`${styles['dv_cuoutnry_phy_title']}`}>公立大学列表</div>

          <div className={`${styles['img_single']}`} style={{ "width": "100%" }}>
            <LazyImage
              className='border-radius'
              imgUrl={
                require('./assets/img/7.jpg')
              } />
            <LazyImage
              className='border-radius'
              imgUrl={
                require('./assets/img/8.jpg')
              } />
          </div>

          <div className={`${styles['dv_cuoutnry_phy_title']}`}>我能学什么</div>

          <div className={`${styles['img_single']}`} style={{ "width": "100%" }}>
            <LazyImage
              className='border-radius'
              imgUrl={
                require('./assets/img/9.jpg')
              } />

          </div>

          <div className={`${styles['dv_cuoutnry_phy_title']}`}>公立大学</div>

          <div className={`${styles['img_single']}`} style={{ "width": "100%" }}>
            <LazyImage
              className='border-radius'
              imgUrl={
                require('./assets/img/10.jpg')
              } />

          </div>
          <div className={`${styles['dv_cuoutnry_phy_title']}`}>怎么考</div>

          <div className={`${styles['img_single']}`} style={{ "width": "100%" }}>
            <LazyImage
              className='border-radius'
              imgUrl={
                require('./assets/img/11.jpg')
              } />

          </div>
          <div className={`${styles['dv_cuoutnry_phy_title']}`}>考试安排</div>

          <div className={`${styles['img_single']}`} style={{ "width": "100%" }}>
            <LazyImage
              className='border-radius'
              imgUrl={
                require('./assets/img/12.jpg')
              } />

          </div>












        </div>


      </div >
    );
  }
}
export default DDS_lanhupage_0;
